// extracted by mini-css-extract-plugin
export var attachment = "_n8-a";
export var emailContainer = "_n8-4";
export var emailContentPaddedContainer = "_n8-b";
export var emailHeader = "_n8-6";
export var emailIframe = "_n8-3";
export var emailInfoIcon = "_n8-9";
export var emailShortenedSummary = "_n8-e";
export var infoDropdown = "_n8-0";
export var infoRowBoundedContent = "_n8-d";
export var internal = "_n8-5";
export var merchant = "_n8-8";
export var messageInputContainer = "_n8-h";
export var normal = "_n8-7";
export var replyCard = "_n8-f";
export var subtleButton = "_n8-1";
export var subtleButtonIconContainer = "_n8-2";
export var toggleViewRepliesButton = "_n8-c";
export var wrappingText = "_n8-g";